/**
 * @author 3173
 * @description 直播列表
 * @Date 2020/9/28
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '../../../../tool'
import {Col, Row} from "antd";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength,Session } = utils_tool;
let {  WizBrowserExport ,WizCard,WizRow,WizCol} = component_tool;


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/live/liveList/liveStatisticsList') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('liveInfo', record)
      } else {
        record = Session.get('liveInfo') || 0
      }
    }
  } else {
    record = Session.get('liveInfo') || 0
  }
  if (record.liveType == 1){
    record.liveType = '视频直播';
  }else if (record.liveType == 2){
    record.liveType = '互动直播';
  }else if(record.liveType == 3){
    record.liveType = '点播';
  }else if(record.liveType == 4){
    record.liveType = '远程认证';
  }else if(record.liveType == 5){
    record.liveType = '直播课堂';
  }else if(record.liveType == 6){
    record.liveType = '远程评估';
  }else if(record.liveType == 7) {
    record.liveType = '企微会议';
  }else if(record.liveType == 8) {
    record.liveType = '企微直播';
  }
  if (record.state == 1){
    record.state = '草稿';
  }else if (record.state == 2){
    record.state = '预告中';
  }else if(record.state == 3){
    record.state = '直播中';
  }else if(record.state == 4){
    record.state = '已结束';
  }
  return record
}



class LiveStatisticsList extends WizContainer {

  componentName = 'liveStatisticsList';

  constructor(props) {
    super(props);
    this.state = {
    }
    this.initialValue = getParamRecord(props.history);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['name'] = checkStrLength(val['name'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let record = this.props.location.record;
    let entityId = '';
    if (record) {
      Session.set('liveRecord',record);
    }
    if (Session.get('liveRecord')){
      let liveRecord = Session.get('liveRecord');
      entityId = liveRecord.id;
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({entityId,entityType:1}),
      apiDataFormat: {
        list: this._handleListData,
        export: this._handleFile,
        updateTrainingStatistics: this._handleCMD,
      },
      entityId:entityId
    })
    return(
      <>
      <WizCard title={'直播信息'}>
        <Row style={{ marginTop: 10 }}>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播名称:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.name}</span>
          </Col>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播状态:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.state}</span>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播类型:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.liveType}</span>
          </Col>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>开播时间:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.startDate}</span>
          </Col>
        </Row>
      </WizCard>
      <WizCard title={'参训统计列表'}>
      <WizReduxTemplate {..._reduxTemplateCofig}  />
      </WizCard>
      </>
    );

  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LiveStatisticsList);
